<template>
    <div class="container-md container-app p-0 ">
        <inc-registration-done v-if="this.registration_done"></inc-registration-done>
        <div class="wrapper" v-else>
            <div class="header">
                <h1>{{$t('account.registrazione')}}</h1>
            </div>
            <div class="content content-full">
                <form>
                    <div class="title">{{$t('prenotazione_tavolo.dati')}}</div>
                    <div class="container">
                        <div class="row row-sezione">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="form.nome"
                                           :placeholder="$t('nome')+' *'">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input v-model="form.cognome" type="text" class="form-control"
                                           :placeholder="$t('cognome')+' *'">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input v-model="form.telefono" type="text" class="form-control"
                                           :placeholder="$t('telefono')+' *'">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input v-model="form.email" type="text" class="form-control"
                                           :placeholder="$t('email')+' *'">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title">{{$t('account.dati_account')}}</div>
                    <div class="container">
                        <div class="row row-sezione">
                            <div :class="this.isAppleRegistration ? 'col-md-12' : 'col-md-6'">
                                <div class="form-group">
                                    <input type="text" class="form-control" :value="this.form.email"
                                           :placeholder="$t('account.account')+'/'+$t('email')+' *'" disabled/>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="!this.isAppleRegistration">
                                <div class="form-group">
                                    <input v-model="form.password" type="password" class="form-control"
                                           :placeholder="$t('password')+' *'" autocomplete>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="this.locale.configurazione_delivery.f_attivo">
                        <div class="title">{{$t('account.inserire_indirizzo_domanda')}}?</div>
                        <div class="container">
                            <div class="row row-sezione">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input v-model="form.indirizzi.consegna.indirizzo" type="text"
                                               class="form-control" :placeholder="$t('account.via')">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input v-model="form.indirizzi.consegna.numero"
                                               type="text"
                                               class="form-control" :placeholder="$t('account.civico')">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" v-model="form.indirizzi.consegna.campanello"
                                               class="form-control"
                                               :placeholder="$t('account.campanello')">
                                    </div>
                                </div>
                                <div class="col-md-6"
                                     v-if="this.locale.configurazione_delivery.tipo_modalita_zone === 'MANUALE'">
                                    <div class="form-group">
                                        <select v-model="form.indirizzi.consegna.id_consegna_citta"
                                                class="form-control">
                                            <option value="">{{$t('account.sel_city')}}</option>
                                            <option v-for="option in this.delivery_cities_manual"
                                                    :value="option.id">
                                                {{option.nome}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                     v-if="this.locale.configurazione_delivery.tipo_modalita_zone === 'MANUALE'">
                                    <div class="form-group">
                                        <select v-model="form.indirizzi.consegna.id_consegna_zona"
                                                class="form-control"
                                                :disabled="!this.city_zones.length">
                                            <option value="">{{$t('account.sel_cap')}}</option>
                                            <option v-for="option in this.city_zones"
                                                    :value="option.id">
                                                {{option.nome}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6"
                                     v-if="this.locale.configurazione_delivery.tipo_modalita_zone === 'COORDINATE'">
                                    <div class="form-group">
                                        <input type="text" v-model="form.indirizzi.consegna.localita_citta"
                                               class="form-control"
                                               :placeholder="$t('account.citta')">
                                    </div>
                                </div>
                                <div class="col-sm-4"
                                     v-if="this.locale.configurazione_delivery.tipo_modalita_zone === 'COORDINATE'">
                                    <div class="form-group">
                                        <input type="text" v-model="form.indirizzi.consegna.cap_citta"
                                               class="form-control"
                                               :placeholder="$t('account.cap')" value="">
                                    </div>
                                </div>
                                <div class="col-md-2"
                                     v-if="this.locale.configurazione_delivery.tipo_modalita_zone === 'COORDINATE'">
                                    <div class="form-group">
                                        <input type="text" v-model="form.indirizzi.consegna.provincia"
                                               class="form-control"
                                               :maxlength="this.delivery_province_length"
                                               :placeholder="$t('account.prv')">
                                    </div>
                                </div>
                                <div class="col-sm-6"
                                     v-if="this.locale.configurazione_delivery.tipo_modalita_zone === 'COORDINATE'">
                                    <div class="form-group">
                                        <select v-model="form.indirizzi.consegna.nazione" class="form-control"
                                                @change="truncateDeliveryProvince">
                                            <option value="">{{$t('account.sel_country')}}</option>
                                            <option v-for="country in this.countries"
                                                    :value="country.iso">
                                                {{country.traduzione_ll.nome}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <textarea v-model="form.indirizzi.consegna.note" class="form-control"
                                                  :placeholder="$t('note')"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title">{{$t('account.inserire_ind_fat_domanda')}}?</div>
                    <div class="container">
                        <div class="d-flex align-items-center justify-content-between mr-5 ml-5 mt-2 pl-5 pr-5"
                             v-if="this.locale.f_fat_obbligatoria">
                            <mcw-radio
                                id="billing-type-azienda"
                                v-model="form.billing_type"
                                :label="this.$t('azienda')"
                                name="billing_type"
                                value="AZIENDA"
                            />
                            <mcw-radio
                                id="billing-type-privato"
                                v-model="form.billing_type"
                                :label="this.$t('privato')"
                                name="billing_type"
                                value="PRIVATO"
                            />
                        </div>
                        <div class="row row-sezione">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.ragione_sociale"
                                                   type="text" class="form-control"
                                                   :placeholder="$t('account.reg_soc')"/>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.p_iva"
                                                   type="text" class="form-control"
                                                   :placeholder="$t('piva')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.cod_fisc" type="text"
                                                   class="form-control"
                                                   :placeholder="$t('cod_fisc')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.indirizzo"
                                                   type="text" class="form-control" :placeholder="$t('account.via')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.numero"
                                                   type="text" class="form-control"
                                                   :placeholder="$t('account.civico')"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.localita_citta"
                                                   type="text" class="form-control" :placeholder="$t('account.citta')">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.cap_citta"
                                                   type="text" class="form-control" :placeholder="$t('account.cap')">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.provincia"
                                                   :maxlength="this.billing_province_length"
                                                   type="text" class="form-control" :placeholder="$t('account.prv')">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <select v-model="form.indirizzi.fatturazione.nazione" class="form-control"
                                                    @change="truncateBillingProvince">
                                                <option value="">{{$t('account.sel_country')}}</option>
                                                <option v-for="country in this.countries"
                                                        :value="country.iso">
                                                    {{country.traduzione_ll.nome}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.sdi"
                                                   type="text" class="form-control" placeholder="SDI">
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-if="this.form.billing_type === 'AZIENDA'">
                                        <div class="form-group">
                                            <input v-model="form.indirizzi.fatturazione.pec"
                                                   type="text" class="form-control" placeholder="PEC">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-for="checkbox in this.checkboxes">
                                <mcw-checkbox v-model="form[checkbox.db_name]" class="d-flex align-items-start">
                                    <div class="pt-2">
                                      {{checkbox.label}}
                                      <a v-if="checkbox.url" href="#" class="a3" @click.prevent="openPrivacyModal(checkbox)">
                                          <i>{{$t('news.leggi')}} »</i>
                                      </a>
                                    </div>
                                </mcw-checkbox>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="container">
                        <div class="row-sezione d-flex justify-content-between">
                            <router-link :to="{name:'home'}">
                                <button type="button" class="btn btn-default">
                                    {{$t('btn_annulla')}}
                                </button>
                            </router-link>
                            <button type="button" class="btn btn-primary w-auto" @click="register()"
                                    :disabled="this.loading_visible">
                                {{$t('account.registrarti')}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {login, registration} from '../../api/account';
import {getMixedInfo, getPrivacyCheckboxes} from '../../api/restaurant';
import {checkEmptyObject} from "../../libraries/utils";
import {getCountries} from "../../api/mixed";

import IncRegistrationDone from './partials/IncRegistrationDone';
import ModalErrors from "../partials/ModalErrors";

export default {
    inject: {
        privacyModalProvider: {
            from: 'openPrivacyModal',
            default: null
        }
    },
    components: {
        ModalErrors,
        IncRegistrationDone
    },
    data: function () {
        return {
            delivery_cities: [],
            checkboxes: [],
            form: this.initializeFormParams(),
            registration_done: false,
            countries: []
        }
    },
    created() {
        if (this.locale.f_fat_obbligatoria) {
            this.form.billing_type = 'PRIVATO'
        }

        this.fetchInfo();
    },
    computed: {
        isAppleRegistration: function () {
            return this.form.from === 'APPLE';
        },
        appleAuthParams: function () {
            return this.$route.params.appleAuth || null;
        },
        delivery_cities_manual: function () {
            return this.delivery_cities.filter((city) => {
                return city.tipo === 'MANUALE';
            });
        },
        selected_delivery_city: function () {
            return this.delivery_cities.find((city) => {
                return city.id === this.form.indirizzi.consegna.id_consegna_citta;
            });
        },
        city_zones: function () {
            if (this.selected_delivery_city) {
                return this.selected_delivery_city.zone;
            }

            return [];
        },
        delivery_province_length: function () {
            return this.getProvinceLength(this.form.indirizzi.consegna.nazione);
        },
        billing_province_length: function () {
            return this.getProvinceLength(this.form.indirizzi.fatturazione.nazione);
        },
        ...mapState('restaurant', {
            locale: (state) => state.locale,
            id_ristorante: (state) => state.id
        }),
        ...mapState('localization', {
            language: (state) => state.language
        }),
        ...mapState('global', {
            loading_visible: (state) => state.loading_visible
        })
    },
    watch: {
        'form.indirizzi.consegna.id_consegna_citta': function (oldval, newval) {
            if (oldval !== newval) {
                this.form.indirizzi.consegna.id_consegna_zona = '';
            }
        },
        language: function () {
            this.fetchInfo();
        },
    },
    methods: {
        fetchInfo: function () {
            this.showLoading(true);
            axios.all([
                getPrivacyCheckboxes(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                }),
                getMixedInfo(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    consegne_citta: true
                }),
                getCountries(this.language, {})
            ]).then(axios.spread((...responses) => {
                // use/access the results
                const responsePrivacy = responses[0];
                const responseInfo = responses[1];
                const responseCountries = responses[2];

                this.delivery_cities = responseInfo.consegne_citta;
                this.checkboxes = responsePrivacy.checkboxes;
                this.countries = responseCountries.countries;
            })).catch(messages => {
                // react on errors.
                this.showModalErrors({
                    title: 'ACCOUNT',
                    errors: messages
                });
            }).finally(() => {
                this.showLoading(false);
            });
        },
        ...mapActions('global', [
            'showLoading',
            'showModalErrors'
        ]),
        ...mapActions('localization', [
            'setLanguage'
        ]),
        ...mapActions('auth', [
            'saveUserData'
        ]),
        register: function () {
            this.showLoading(true);

            let billingAddress = {...this.form.indirizzi.fatturazione};

            if (this.locale.f_fat_obbligatoria) {
                billingAddress.fatturazione_tipo = this.form.billing_type;
            } else if (checkEmptyObject(billingAddress)) {
                billingAddress = null;
            }

            let deliveryAddress = null;
            if (!checkEmptyObject(this.form.indirizzi.consegna)) {
                deliveryAddress = Object.assign({}, {
                    tipo: this.locale.configurazione_delivery.tipo_modalita_zone
                }, this.form.indirizzi.consegna);
            }

            let params = Object.assign({}, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                username: this.form.email
            }, this.form, {
                indirizzi: {
                    consegna: deliveryAddress,
                    fatturazione: billingAddress
                }
            });

            delete params.billing_type;

            //accrocchio in quanto ws vuole o 1 o 0
            this.checkboxes.forEach((checkbox) => {
                if (params.hasOwnProperty(checkbox.db_name)) {
                    params[checkbox.db_name] = params[checkbox.db_name] ? 1 : 0
                }
            });

            registration(this.language, params).then((response) => {
                this.form = this.initializeFormParams();
                if (this.isAppleRegistration) {
                    return this.completeAppleRegistration();
                }

                this.registration_done = true;
            }).catch(({messages}) => {
                this.showModalErrors({
                    title: 'ACCOUNT',
                    errors: messages
                });
            }).finally(() => {
                this.showLoading(false);
            });
        },
        completeAppleRegistration: function () {
            const payload = this.appleAuthParams;

            if (!payload) {
                this.registration_done = true;
                return Promise.resolve();
            }

            if (!payload || !payload.identityToken || !payload.user) {
                this.registration_done = true;
                return Promise.resolve();
            }

            return login(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                apple_identity_token: payload.identityToken,
                apple_client_user: payload.user,
                info: payload.info || {}
            }).then((response) => {
                this.saveUserData({
                    api_key: response.api_key,
                    language: response.cod_lingua,
                    email: response.account
                });

                if (this.language !== response.cod_lingua) {
                    this.setLanguage(response.cod_lingua);
                }

                this.$router.replace({name: 'home'});
            }).catch(() => {
                this.registration_done = true;
            });
        },
        initializeFormParams: function () {
            return {
                nome: this.$route.query.nome || '',
                cognome: this.$route.query.cognome || '',
                telefono: '',
                email: this.$route.query.email || '',
                password: '',
                from: this.$route.query.from || '',
                apple_identity_sub: this.$route.query.apple_identity_sub || '',
                indirizzi: {
                    consegna: {
                        indirizzo: '',
                        numero: '',
                        campanello: '',
                        id_consegna_citta: '',
                        id_consegna_zona: '',
                        note: '',
                        //COORDINATE
                        localita_citta: '',
                        provincia: '',
                        cap_citta: '',
                        nazione: ''
                    },
                    fatturazione: {
                        ragione_sociale: '',
                        p_iva: '',
                        cod_fisc: '',
                        indirizzo: '',
                        numero: '',
                        localita_citta: '',
                        cap_citta: '',
                        provincia: '',
                        nazione: '',
                        sdi: '',
                        pec: ''
                    }
                },
                billing_type: 'AZIENDA'
            }
        },
        getProvinceLength: function (iso) {
            if (iso === 'IT') {
                return 2;
            }

            return null;
        },
        truncateDeliveryProvince: function () {
            if (this.delivery_province_length) {
                this.form.indirizzi.consegna.provincia = this.form.indirizzi.consegna.provincia.substr(0, this.delivery_province_length);
            }
        },
        truncateBillingProvince: function () {
            if (this.billing_province_length) {
                this.form.indirizzi.fatturazione.provincia = this.form.indirizzi.fatturazione.provincia.substr(0, this.billing_province_length);
            }
        },
        openPrivacyModal: function (checkbox) {
            if (this.privacyModalProvider) {
                this.privacyModalProvider(checkbox);
            }
        }
    }
}
</script>
